/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import { hhmmToMin } from '@mummssoftware/utils/timeUtils';
import { hasTimerDuration } from '@mummssoftware/utils/utils';
import { handleTimeChange } from '@mummssoftware/utils/visitUtils';
import { formatMMtoHHMMArr } from '@mummssoftware/utils/formatters';
import {
  SET_CC_TIME,
  VisitsGlobalContext,
  GlobalContext,
} from '@mummssoftware/global-context';
import { TimerDiv, EditTimeDiv, TimerText } from './styledDiv';
import { useStyles } from './style';
import defaults from '../../../../translations/en.json';

type CCTimerProps = {
  isCCRoleGroup: boolean;
  continuouscarehours: null | number;
};
/*
 * CCTimer is only available to users in the Nurse or Aide role group
 * continuous care time can not be greater than the visit duration, tracks 'time duration'
 */
export const CCTimer = ({
  isCCRoleGroup,
  continuouscarehours,
}: CCTimerProps) => {
  const classes = useStyles();
  const timerId = 'hour-edit';
  const { dispatchVG, timerDuration, ccTime } = useContext(VisitsGlobalContext);
  const { editingPastVisit } = useContext(GlobalContext);

  const ccareTime = continuouscarehours
    ? formatMMtoHHMMArr(continuouscarehours)
    : ['00', '00'];

  const maxMin =
    (editingPastVisit as any)?.durationmins ||
    (editingPastVisit as any)?.duration ||
    0;
  // Max value (in mins) set in relation to the visit duration
  const [maxValue, setMaxValue] = useState<number>(maxMin);
  const [hour, minute] = ccTime ?? (ccareTime as any).map(String);

  const onHourChange = (event: any) => {
    const targetValue = event.target.value;
    // if the new value does not exceed the max set by visit duration
    if (maxValue >= hhmmToMin(targetValue || '0', minute)) {
      dispatchVG({
        type: SET_CC_TIME,
        payload: [targetValue, minute],
      });
      // if the value does exceed the max, set the new value to the max
    } else if (hasTimerDuration(timerDuration)) {
      dispatchVG({
        type: SET_CC_TIME,
        payload: [timerDuration[0], minute],
      });
    }
  };

  const onMinChange = (event: any) => {
    const targetValue = event.target.value;
    if (maxValue >= hhmmToMin(hour, targetValue || '0')) {
      dispatchVG({
        type: SET_CC_TIME,
        payload: [hour, targetValue],
      });
    } else if (hasTimerDuration(timerDuration)) {
      dispatchVG({
        type: SET_CC_TIME,
        payload: timerDuration,
      });
    }
  };

  useEffect(() => {
    if (hasTimerDuration(timerDuration)) {
      // set the maximum value
      timerDuration &&
        setMaxValue(hhmmToMin(timerDuration[0], timerDuration[1]));
      // if the new maxValue is less than the cc timer, lower the cc timer to the new max
      if (timerDuration && ccTime) {
        // hour field
        if (parseInt(timerDuration[0]) < parseInt(ccTime[0])) {
          dispatchVG({
            type: SET_CC_TIME,
            payload: [timerDuration[0], minute],
          });
        }
        // min field
        if (parseInt(timerDuration[1]) < parseInt(ccTime[1])) {
          dispatchVG({
            type: SET_CC_TIME,
            payload: [hour, timerDuration[1]],
          });
        }
      }
    }
  }, [timerDuration]);

  const inputProps = {
    classes: {
      input: classes.input,
      root: classes.outlined,
    },
  };
  const handleHourChange = handleTimeChange(onHourChange);
  const handleMinChange = handleTimeChange(onMinChange);

  return (
    <EditTimeDiv className="edit-time-div">
      <FormHelperText id="component-helper-text" disabled={!isCCRoleGroup}>
        {defaults.editCC}
      </FormHelperText>
      <TimerDiv edit>
        <TextField
          label="HH"
          id={timerId}
          variant="outlined"
          value={hour}
          InputProps={inputProps}
          onChange={handleHourChange}
          disabled={!isCCRoleGroup}
          // eslint-disable-next-line react/jsx-no-duplicate-props
          inputProps={{ maxLength: 2 }}
          InputLabelProps={{
            shrink: true,
            classes: { root: classes.labelInput },
          }}
        />
        <TimerText>:</TimerText>
        <TextField
          label="MM"
          id="min-edit"
          variant="outlined"
          value={minute}
          InputProps={inputProps}
          onChange={handleMinChange}
          disabled={!isCCRoleGroup}
          // eslint-disable-next-line react/jsx-no-duplicate-props
          inputProps={{ maxLength: 2 }}
          InputLabelProps={{
            shrink: true,
            classes: { root: classes.labelInput },
          }}
        />
      </TimerDiv>
    </EditTimeDiv>
  );
};

export default CCTimer;
